export const VERSION = '4.2.11-bowl';
export const GIT_HASH = 'cf001824c535db190f473f8118e28880d0bb45e7';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'bowl';
